// @flow

// Rather than repeating a ton of calls to track with a long list of parameters
// all over PinRep, useTrackingCallback pulls in params from
// useTrackingParameters and calls track along with specified additions.

import { useCallback } from 'react';
import { track } from 'app/common/lib/react/analytics';
import { useTrackingParameters } from 'app/common/react/components/PinRep/TrackingParametersContext';

export default function useTrackingCallback(
  eventType: $Values<PCONST.thrift.EventType>,
  additionalData?: Object,
) {
  const { componentType, contextLogData, viewParameter, viewType } = useTrackingParameters();

  return useCallback(
    () => {
      track(eventType, {
        component: componentType,
        view: viewType,
        viewParameter,
        ...contextLogData,
        ...(additionalData || {}),
      });
    },
    [eventType, componentType, contextLogData, viewParameter, viewType],
  );
}
